import * as React from "react";
import * as Helpers from "../helpers";
import styles from "./InputOptions.module.scss";

type InputOptionsProps = InputProps & {
    options: OptionItem[],
    is_exclusive: boolean,
    equal_labels?: boolean
};

const InputOptions: React.FunctionComponent<InputOptionsProps> = props => {
    function handleMultiOptionsUpdate(value: string) {
        if (props.is_exclusive || !values) {
            props.update_value(props.name, value);
            return;
        }

        if (values.indexOf(value) === -1) {
            props.update_value(props.name, [...values, value].join(","));
        }
        else
        {
            const updatedValues = values.filter(e => e != value);
            props.update_value(props.name, updatedValues.length ? updatedValues.join(",") : undefined);
        }
    }

    function handleKeyDownOnLabel(ev: React.KeyboardEvent, value: string)
    {
        if (ev.code === "Enter" || ev.code === "Space") {
            ev.preventDefault();
            handleMultiOptionsUpdate(value);
        }
    }

    const values = props.value?.split(",") ?? [];
    const showValidation = !Helpers.TriggerValidationSingle((props.value || "").trim(), props.required) && props.validation_triggered;
    const elemRef = React.useRef<HTMLDivElement>(null);
    if (showValidation && !props.validation_get_scrolled() && elemRef.current) {
        props.validation_set_scrolled();
        elemRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }

    return <div ref={elemRef} className={styles.outer}>
        <div className={`${styles.wrapper} ${showValidation ? styles.hasValidation : ""}`}>
            <h4>{props.label} {props.required ? <sub className={styles.required}>*</sub> : null}</h4>
            {props.description}
            <div className={`${styles.optionsRow} ${props.equal_labels ? styles.equalLabels : ""} ${props.additional_classes ? props.additional_classes : ""}`}>
                {props.options.map(item=>
                    {
                        const id = `${props.name}_${item.value.replace(" ", "_")}`;
                        return <React.Fragment key={id}>
                            <input
                                id={id}
                                name={props.is_exclusive ? props.name : id}
                                type={props.is_exclusive ? "radio" : "checkbox"}
                                checked={values.indexOf(item.value) !== -1}
                                onChange={() => handleMultiOptionsUpdate(item.value)}
                                style={{ display: "none" }}
                            />
                            <label htmlFor={id} className={(values.indexOf(item.value) !== -1 ? styles.active : "")} tabIndex={0} onKeyDown={(ev) => handleKeyDownOnLabel(ev, item.value)}>
                                {item.label}
                                {item.details ? <div className={styles.optionDetails}>{item.details}</div> : null}
                            </label>
                        </React.Fragment>;
                    }
                )}
            </div>
        </div>
        {showValidation ? <div className={styles.validation} role="alert">{props.validation_message ? <>{props.validation_message}</> : <>Please enter a <span style={{ textTransform: "lowercase" }}>{props.label}</span>.</>}</div> : null}
    </div>
}

export default InputOptions;